<template>
  <div>
    <div
      :class="[gameType === 'MW' ? 'modal modal-game_memory_wizard' : gameType === 'ODD' ? 'modal modal-game_odd_object': 'modal modal-game_spot_difference', isIos ? 'ui_desc_ios' : '']"
      :id="[gameType === 'MW' ? 'modal-game_memory_wizard' : gameType === 'ODD' ? 'modal-game_odd_object': 'modal-game_spot_difference']">
      <div class="modal__content won_game_modal">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header modal_ti_header">
          <div class="row gamepage_header">
            <img v-if="gameType === 'MW'" class="gamepage_logo " src="static/images/logo-memory-wizard.png"/>
            <img v-if="gameType === 'ODD'" class="gamepage_logo " src="static/images/logo-odd-object.png"/>
            <img v-if="gameType === 'SD'" class="gamepage_logo " src="static/images/logo-spot-difference.png"/>
            <h1 v-if="gameType === 'MW'">{{ getTranslations.home_game_memory_wizard }}</h1>
            <h1 v-if="gameType === 'ODD'">{{ getTranslations.home_game_odd_game }}</h1>
            <h1 v-if="gameType === 'SD'">{{ getTranslations.home_game_sd_game }}</h1>
            <p>{{ getTranslations.home_modals_post_prize_great_you_won }}</p>
          </div>
        </div>
        <div class="modal__body">
          <h1 class="prize_won_headline">{{ playersDetails.winDTO.name }}</h1>

          <div class="prize_won_image prize_won_image_prize">
            <img :src="playersDetails.winDTO.imageWonUrl"/>
            <div class="prize_won_image prize_won_image_conffeti"></div>
          </div>

          <p class="cta_support">{{ getTranslations.home_modals_post_prize_you_will }}</p>
          <a class="ti_btn--green modal_cta" style="cursor:pointer"
             @click.prevent="playGameMethodWithDifferentImpl(gameType)">{{
            getTranslations.home_modals_post_prize_play_again }}</a>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import GameIntro from './GameIntro';
import modals from '../../../common/modals';

export default {
  name: 'post-game-prize',
  mixins: [NewGameMixin],
  data() {
    return {
      showedModal: false,
      currentModal: null,
      isIos: false,
    };
  },
  created() {
    console.log('in PostGamePrize created hook');
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('game', [
      'resetGameState',
      'resetPrizeData',
      'isGamePageFlow',
      'updateGameType',
    ]),
    playGameMethodWithDifferentImpl(gameType) {
      console.log('playGameMethodWithDifferentImpl');
      if (this.isEligibleToPlay(gameType)) {
        console.log('callGamePlayAsUsual');
        this.playGame(gameType);
      } else {
        this.storeModalForHomePage(GameIntro);
        modals.showHideModalForGameNotificationPage(this);
      }
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('game', [
      'playersDetails',
      'gameType',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/PostGamePrize.vue